import { DateRange } from '@mui/x-date-pickers-pro/DateRangePicker';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

type UseFilterTexts<T> = {
  elements?: {
    key: keyof T;
    values: Array<any>;
  };
  range?: {
    value: DateRange<Date>;
  };
};

function fancyPlaceholderTextForItems<T>(items: T[], key: keyof T) {
  return `(${items.length}) ${items.map((item) => item[key]).join(', ')}`;
}

function fancyPlaceholderTextForDateRanges(
  range: DateRange<Date>,
  t: TFunction<'common'>,
) {
  const [start, end] = range;
  // TODO use user config
  if (end === start) return `${start}`;
  if (end) {
    if (start) {
      return `${t('filters.date.from')} ${start} ${t(
        'filters.date.to',
      )} ${end}`;
    }
    return `${t('filters.date.fromPass')} ${end}`;
  }
  return `${t('filters.date.from')} ${start} ${t('filters.date.toToday')}`;
}

export function useFilterTexts<T>(args: UseFilterTexts<T>) {
  const { t } = useTranslation();
  const { elements, range } = args;

  const dropdownPlaceholderDefault = t('filters.dropdownDefault');
  const searchPlaceholderDefault = t('filters.searchDefault');

  let dropdownPlaceholderText = '';

  if (range) {
    dropdownPlaceholderText =
      range.value[0] || range.value[1]
        ? fancyPlaceholderTextForDateRanges(range.value, t)
        : dropdownPlaceholderDefault;
  }
  if (elements) {
    const { values, key } = elements;
    dropdownPlaceholderText = values.length
      ? fancyPlaceholderTextForItems<T>(values, key)
      : dropdownPlaceholderDefault;
  }

  return {
    dropdownPlaceholderText,
    searchPlaceholderDefault,
  };
}
